import SensorVariable from '@/models/SensorVariable';

export default {

  state: {

    current: null,

    range: {
      start: null,
      end: null,
    },

  },

  mutations: {

    SET_SENSOR_VARIABLE(state, value) {
      state.current = value;
    },


    setDateRangeOld(state, value) {
      if (!value.start && !value.end) {
        const msg = 'In mutation \'setDateRange\', you cannot set the range without ' +
          'passing either a start or end property!';
        throw new Error(msg);
      }
      console.log(value);
      state.range.interval = state.range.interval.set(value);
    },

  },

  actions: {

    initializeSensorVariable({ rootState, state, commit }, { data, range, variable }) {
      const options = rootState.universal.appOptions;
      const sensorVariable = new SensorVariable({
        data, range, variable, options,
      });
      commit('SET_SENSOR_VARIABLE', sensorVariable);
    },

  },

};



// WEBPACK FOOTER //
// ./src/store/sensor-variable/index.js